import React, {Component} from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleTextArea from "../../../modules/simpleTextArea";
import SimpleCheckBox from "../../../modules/SimpleCheckBox";
import Api from "../../../Services/Api";
import M from "moment";
import withFormGroup from "../../../modules/commons/withFormGroup";
import {ACTIVITY_TYPE} from "../../common/Constants";
import * as R from "ramda";
import {mapToObjectDDL} from "../../common/mapper";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";

class ClaimC1Modifying extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            tempClaimNo: null,
            lokasiOptions: [],
            claimStatusOptions: [],
            engineNumberOptions: [],
            printVisible: false,
            warningAlertVisible: false,
            warningAlertMessage: "",
        }
    }

    async componentDidMount() {
        console.log("controls", this.props.controls)
        await this.getTempClaimNo();
        await this.fetchLokasiOptions();
        await this.fetchClaimStatusOptions();
        if (!R.isEmpty(this.props.controls.locator.value)) {
            await this.getEngineNumberByKodeLocator(this.props.controls.locator.value.value)
        }

        this.props.setValue("claimNo", this.props.controls.claimNo.value || this.state.tempClaimNo)
        this.props.setValue("claimDate", this.props.controls.claimDate.value || M(new Date).format("DD-MM-YYYY"))
        this.props.setValue("kodeCabang", this.props.dataCabang.value)
    }

    getTempClaimNo = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getGenSeqWithoutSave(
                {
                    seqType: "ClaimC1",
                    nosDealerCode: this.props.userAccess.idRefObj,
                    transactionType: "ClaimC1"
                }
            )
            if (response.ok) {
                this.setState((prevValue) => ({
                        ...prevValue,
                        tempClaimNo: response.data
                    })
                )
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    fetchLokasiOptions = async () => {
        try {
            let response = await Api.create(
                "NAGAMAS_MASTER_DATA"
            ).getAllMasterLocationPagingByParam({
                paramFilters: {kodeCabang: this.props.userAccess.idRefObj}
            });
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    lokasiOptions: response.data.data.map((item) =>
                        mapToObjectDDL(item.nameLocation, item.kodeLocation))
                }))
            }
        } catch (errors) {
            console.log("errors", errors)
        }
    }

    handlePrint = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            printVisible: !prevValue.printVisible,
        }))
    }

    fetchClaimStatusOptions = async () => {
        try {
            let response = await Api.create(
                "NAGAMAS_MASTER_DATA"
            ).getAllBizparByParam({
                paramFilters: {bizparCategory: "CLAIM_C1_TYPE"}
            });
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    claimStatusOptions: response.data.data.map((item) =>
                        mapToObjectDDL(item.value, item.key))
                }))
            }
        } catch (errors) {
            console.log("errors", errors)
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (!this.props.validate()) {
            this.handleWarningAlertVisibility("Ada field yang belum terisi. Harap dilengkapi sebelum disimpan.")
            return;
        }

        this.props.onSubmit(this.props.controls, this.props.activityTypes);
    }

    handleHotline = () => {
        this.props.setValue("hotlineOrder", !this.props.controls.hotlineOrder.value);
    }

    handleChangeLocator = async (kodeLocator) => {
        this.props.setValue("engineNumber", {});
        this.props.setValue("frameNumber", "");
        this.props.setValue("series", "");
        this.props.setValue("type", "");
        this.props.setValue("warna", "");
        this.props.setValue("variant", "");
        this.props.setValue("slNo", "");
        this.props.setValue("spbmNo", "");
        await this.getEngineNumberByKodeLocator(kodeLocator)
    }

    getEngineNumberByKodeLocator = async (kodeLocator) => {
        try {
            let req = {
                kodeLocator: kodeLocator
            }
            let response = await Api.create("NAGAMAS_TRANSACTION").getEngineNumberByKodeLocator(req);
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    engineNumberOptions: response.data.data.map(obj => mapToObjectDDL(obj, obj))
                }))
            }
        } catch (error) {
            console.log("error", error);
        }
    }

    handleChangeEngineNumber = async (engineNumber) => {
        this.setState((prevState) => ({...prevState, loading: !prevState.loading}))
        try {
            let response = await Api.create("NAGAMAS_TRANSACTION").getUnitDetailByEngineNumber(engineNumber);
            if (response.ok) {
                this.props.setValue("frameNumber", response.data.data.frameNumber);
                this.props.setValue("series", response.data.data.series);
                this.props.setValue("type", response.data.data.type);
                this.props.setValue("warna", response.data.data.warna);
                this.props.setValue("variant", response.data.data.variant);
                this.props.setValue("slNo", response.data.data.slNo);
                this.props.setValue("spbmNo", response.data.data.spbmNo);
            }
        } catch (error) {
            console.log("error", error)
        }
        this.setState((prevState) => ({...prevState, loading: !prevState.loading}))
    }

    handleReset = () => {
        this.props.setValue("engineNumber", "")
        this.props.setValue("frameNumber", "")
        this.props.setValue("spbmNo", "")
        this.props.setValue("slNo", "")
        this.props.setValue("claimStatus", {})
        this.props.setValue("hotlineOrder", false)
        this.props.setValue("noFjb", "")
        this.props.setValue("chronology", "")
        this.props.setValue("locator", "")
        this.props.setValue("series", "")
        this.props.setValue("type", "")
        this.props.setValue("variant", "")
        this.props.setValue("warna", "")
    };

    handleWarningAlertVisibility = (text) => {
        this.setState((prevValue) => ({
            ...prevValue,
            warningAlertVisible: !prevValue.warningAlertVisible,
            warningAlertMessage: text
        }))
    }

    render() {
        return (
            <>
                <SimpleModal
                    title="Form Claim C1"
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <form onSubmit={this.handleSubmit} className={"background-transaparant padding-10px"}>
                                <FlexView column vAlignContent="center">
                                    <FlexView vAlignContent="center" style={{gap: "50px"}}>
                                        <SimpleInput
                                            id="text_claim_no"
                                            name="claimNo"
                                            containerclassname="flex-1"
                                            label="No Claim"
                                            value={this.props.controls.claimNo.value || this.state.tempClaimNo}
                                            readOnly
                                        />
                                        <SimpleInput
                                            id="text_claim_date"
                                            name="claimDate"
                                            containerclassname="flex-1"
                                            label="Tgl Claim"
                                            value={this.props.controls.claimDate.value || M(new Date).format("DD-MM-YYYY")}
                                            readOnly
                                        />
                                    </FlexView>
                                    <FlexView vAlignContent="center" style={{gap: "50px"}}>
                                        <SimpleInput
                                            id="text_kode_cabang"
                                            name="kodeCabang"
                                            containerclassname="flex-1"
                                            label="Kode Cabang"
                                            value={this.props.dataCabang.value}
                                            readOnly
                                        />
                                        <SimpleInput
                                            id="test_nama_cabang"
                                            name="namacabang"
                                            containerclassname="flex-1"
                                            label="Nama Cabang"
                                            value={this.props.dataCabang.label}
                                            readOnly
                                        />
                                    </FlexView>
                                    <SimpleDDL
                                        id="ddl_locator"
                                        name="locator"
                                        label="Lokasi"
                                        box="search"
                                        readOnly={R.equals(
                                            this.props.activityTypes,
                                            ACTIVITY_TYPE.VIEW
                                        )}
                                        errorMessage={this.props.errors.locator}
                                        options={this.state.lokasiOptions}
                                        value={this.props.controls.locator.value}
                                        onChange={(value, {name}) => {
                                            this.props.setValue(name, value);
                                            this.handleChangeLocator(value.value);
                                        }}
                                        mandatory
                                    />
                                    <div
                                        className={"border-all border-100 padding-left-20px padding-right-20px margin-bottom-20px"}>
                                        <FlexView column vAlignContent="center">
                                            <SimpleDDL
                                                id={"ddl_engine_number"}
                                                name={"engineNumber"}
                                                containerclassname="flex-1"
                                                label="No Mesin"
                                                box={"search"}
                                                value={this.props.controls.engineNumber.value}
                                                options={this.state.engineNumberOptions}
                                                mandatory
                                                errorMessage={this.props.errors.engineNumber}
                                                readOnly={R.equals(
                                                    this.props.activityTypes,
                                                    ACTIVITY_TYPE.VIEW
                                                )}
                                                onChange={(value, {name}) => {
                                                    this.props.setValue(name, value);
                                                    this.handleChangeEngineNumber(value.value);
                                                }}
                                            />
                                            <SimpleInput
                                                id={"text_frame_number"}
                                                name={"frameNumber"}
                                                value={this.props.controls.frameNumber.value}
                                                containerclassname="flex-1"
                                                label="No Rangka"
                                                readOnly
                                                onChange={({target}) => this.props.setValue(target.name, target.value)}
                                            />
                                            <FlexView vAlignContent="center" style={{gap: "50px"}}>
                                                <SimpleInput
                                                    id={"text_series"}
                                                    name={"series"}
                                                    value={this.props.controls.series.value}
                                                    containerclassname="flex-1"
                                                    label="Series"
                                                    readOnly
                                                    onChange={({target}) => this.props.setValue(target.name, target.value)}
                                                />
                                                <SimpleInput
                                                    id={"text_type"}
                                                    name={"type"}
                                                    value={this.props.controls.type.value}
                                                    containerclassname="flex-1"
                                                    label="Tipe"
                                                    readOnly
                                                    onChange={({target}) => this.props.setValue(target.name, target.value)}
                                                />
                                            </FlexView>
                                            <FlexView vAlignContent="center" style={{gap: "50px"}}>
                                                <SimpleInput
                                                    id={"text_variant"}
                                                    name={"variant"}
                                                    value={this.props.controls.variant.value}
                                                    containerclassname="flex-1"
                                                    label="Varian"
                                                    readOnly
                                                    onChange={({target}) => this.props.setValue(target.name, target.value)}
                                                />
                                                <SimpleInput
                                                    id={"text_warna"}
                                                    name={"warna"}
                                                    value={this.props.controls.warna.value}
                                                    containerclassname="flex-1"
                                                    label="Warna"
                                                    readOnly
                                                    onChange={({target}) => this.props.setValue(target.name, target.value)}
                                                />
                                            </FlexView>
                                            <FlexView vAlignContent="center" style={{gap: "50px"}}>
                                                <SimpleInput
                                                    id={"text_no_sj"}
                                                    name={"slNo"}
                                                    value={this.props.controls.slNo.value}
                                                    containerclassname="flex-1"
                                                    label="No SJ"
                                                    readOnly
                                                    onChange={({target}) => this.props.setValue(target.name, target.value)}
                                                />
                                                <SimpleInput
                                                    id={"text_no_spbm"}
                                                    name={"spbmNo"}
                                                    value={this.props.controls.spbmNo.value}
                                                    containerclassname="flex-1"
                                                    label="No SPBM"
                                                    readOnly
                                                    onChange={({target}) => this.props.setValue(target.name, target.value)}
                                                />
                                            </FlexView>
                                        </FlexView>
                                    </div>
                                    <SimpleTextArea
                                        id={"text_chronology"}
                                        name={"chronology"}
                                        label="Kronologi"
                                        errorMessage={this.props.errors.chronology}
                                        mandatory
                                        value={this.props.controls.chronology.value}
                                        readOnly={R.equals(
                                            this.props.activityTypes,
                                            ACTIVITY_TYPE.VIEW
                                        )}
                                        onChange={({target}) => this.props.setValue(target.name, target.value)}
                                    />
                                    <FlexView vAlignContent="center" style={{gap: "50px"}}>
                                        <SimpleDDL
                                            id="ddl_claim_status"
                                            label="Status"
                                            name="claimStatus"
                                            box="search"
                                            mandatory
                                            errorMessage={this.props.errors.claimStatus}
                                            containerclassname="flex-2"
                                            readOnly={R.equals(
                                                this.props.activityTypes,
                                                ACTIVITY_TYPE.VIEW
                                            )}
                                            options={this.state.claimStatusOptions}
                                            value={this.props.controls.claimStatus.value}
                                            onChange={(value, {name}) =>
                                                this.props.setValue(name, value)}
                                        />
                                        <SimpleCheckBox
                                            label="Hotline Order"
                                            name="hotlineOrder"
                                            id="check_box_hotline_order"
                                            checked={this.props.controls.hotlineOrder.value}
                                            onChange={this.handleHotline}
                                            disabled={R.equals(
                                                this.props.activityTypes,
                                                ACTIVITY_TYPE.VIEW
                                            )}
                                        />
                                    </FlexView>
                                    <SimpleInput
                                        id="text_no_fjb"
                                        name={"noFjb"}
                                        label="No FJB"
                                        value={this.props.controls.noFjb.value}
                                        readOnly={R.equals(
                                            this.props.activityTypes,
                                            ACTIVITY_TYPE.VIEW
                                        )}
                                        onChange={({target}) => this.props.setValue(target.name, target.value)}
                                    />
                                </FlexView>
                            </form>
                            <FlexView hAlignContent="right">
                                {R.equals(this.props.activityTypes, ACTIVITY_TYPE.UPDATE) && (
                                    <SimpleButton
                                        type="button"
                                        secondary
                                        onClick={() => this.props.onDelete()}
                                    >
                                        Hapus
                                    </SimpleButton>
                                )}
                                {!R.equals(this.props.activityTypes, ACTIVITY_TYPE.VIEW) && (
                                    <SimpleButton
                                        type="button"
                                        secondary
                                        onClick={this.handleReset}
                                    >
                                        Clear
                                    </SimpleButton>
                                )}
                                {R.equals(this.props.activityTypes, ACTIVITY_TYPE.VIEW) && (
                                    <SimpleButton onClick={this.props.onClickClose}>Tutup</SimpleButton>
                                )}
                                <SimpleButton secondary onClick={this.handlePrint}>Cetak</SimpleButton>
                                {!R.equals(this.props.activityTypes, ACTIVITY_TYPE.VIEW) && (
                                    <SimpleButton type="submit" onClick={this.handleSubmit}>Simpan</SimpleButton>
                                )}
                            </FlexView>
                            {this.state.printVisible && (
                                <SimplePrintTable onClearPrint={this.handlePrint}
                                                  targetHtml={"background-transaparant padding-10px"}/>
                            )}

                            {this.state.warningAlertVisible && (
                                <SimpleAlert
                                    title="Claim C1 Unit"
                                    visible={this.state.warningAlertVisible}
                                    onClickClose={() => this.handleWarningAlertVisibility()}
                                    content={this.state.warningAlertMessage}
                                    additionalButtons={
                                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                            <SimpleButton secondary onClick={() => this.handleWarningAlertVisibility()}>OK</SimpleButton>
                                        </FlexView>
                                    }
                                />
                            )}
                        </ModalContainer>
                    }
                />

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        )
    }
}

export default withFormGroup(ClaimC1Modifying);